import React from 'react';

export function AttachmentIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 50"
      {...props}
    >
      <path d="M34 12.5a1 1 0 00-1 1v22.958c0 4.605-3.58 8.334-8 8.334s-8-3.73-8-8.334V10.417c0-2.875 2.24-5.209 5-5.209s5 2.334 5 5.209v21.875c0 1.145-.9 2.083-2 2.083s-2-.938-2-2.083V13.5a1 1 0 00-1-1h-1a1 1 0 00-1 1v18.792c0 2.875 2.24 5.208 5 5.208s5-2.333 5-5.208V10.417c0-4.604-3.58-8.334-8-8.334s-8 3.73-8 8.334v26.041c0 6.334 4.92 11.459 11 11.459s11-5.125 11-11.459V13.5a1 1 0 00-1-1h-1z" />
    </svg>
  );
}
